import {BASE_URL} from '../constants/SystemConstants';

export const MOVERS_URL= BASE_URL + 'movers';
export const MOVERS_GET= 'MOVERS_GET';
export const MOVERS_CREATE= 'MOVERS_CREATE';
export const MOVERS_UPDATE= 'MOVERS_UPDATE';
export const MOVERS_DELETE= 'MOVERS_DELETE';